<template>
  <div id="wrapper-box">
    <div id="wrapper" :class="wrapperClass" class="px-5">
      <nav class="breadcrumb px-0">
        <router-link class="breadcrumb-item" to="/">Home</router-link>
        <span class="breadcrumb-item active">{{
          wrapperClass === "download-reports" ? "Download Reports" : "Ship Info"
        }}</span>
      </nav>
      <nav id="navigation-buttons" class="mx-auto mb-5">
        <router-link
          to="/download-reports"
          :class="{ active: wrapperClass === 'download-reports' }"
          class="btn-download d-inline-block transition scale-effect"
          >DOWNLOAD REPORTS</router-link
        >
        <router-link
          to="/"
          class="home-link d-inline-block transition scale-effect"
          >HOME</router-link
        >
        <router-link
          to="/ship-info"
          :class="{ active: wrapperClass === 'infoships' }"
          class="btn-infoship d-inline-block transition scale-effect"
          >SHIP INFO</router-link
        >
      </nav>
      <transition name="fade-custom" v-on:after-leave="toggleClass()">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page",
  data: function() {
    return {
      wrapperClass: null
    };
  },
  mounted: function() {
    this.toggleClass();
    this.$store.commit("setBackground", "default");
    this.$store.commit("toggleWaves", false);
  },
  computed: {
    pageClass: function() {
      return this.$store.state.pageClass;
    }
  },
  methods: {
    toggleClass: function() {
      return (this.wrapperClass = this.pageClass);
    }
  }
};
</script>

<style scoped></style>
